import { getImageUrl } from '../../domain/utils/image'

export default function (response) {
  return {
    suggests: response.suggests.map((suggest = {}) => {
      const { type, lat, lng, subtype, labels, brand_icon_url, icon_urls, address_components } = suggest

      const iconUrls = icon_urls
        ? {
            iconUrls: icon_urls.map(iconUrl => getImageUrl(iconUrl))
          }
        : {}

      const brandIconUrl = brand_icon_url ? { brandIconUrl: getImageUrl(brand_icon_url) } : {}

      const postcode = address_components?.postcodes?.[0]

      return {
        type,
        lat,
        lng,
        labels,
        ...(subtype ? { subtype } : {}),
        ...iconUrls,
        ...brandIconUrl,
        ...(postcode ? { postcode } : {})
      }
    })
  }
}
